// ✅ Import React for creating the functional component
import React from 'react';

// ✅ Import the CSS for styling the loading screen
import './LoadingScreen.css';

// ✅ This component displays a fullscreen loading spinner with text
export default function LoadingScreen() {
    return (
        <div className="loading-container">
            <div className="loading-content">
                {/* 🌀 Animated loading spinner (styled via CSS) */}
                <div className="spinner"></div>

                {/* ⏳ Loading message displayed to the user */}
                <p className="loading-text">טוען...</p>
            </div>
        </div>
    );
}
